interface xConfig {
  dataPointIndex: number;
  w: {
    config: {
      series: Array<{ data: Array<{ x: string }> }>;
    };
  };
}

export const chartOptions = {
  chart: {
    id: "chartKurva",
    height: 350,
    type: "area",
    zoom: {
      enabled: false,
    },
  },
  yaxis: {
    labels: {
      formatter: function (val: string): string {
        return val;
      },
    },
    min: 1,
    max: 4,
  },
  xaxis: {
    labels: {
      formatter: function (val: string): number {
        return new Date(val).getDate();
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: ["#034694"], // optional, if not defined - uses the shades of same color in series
      inverseColors: true,
      opacityFrom: 1,
      opacityTo: 0,
      stops: [0, 100],
      colorStops: [],
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
    colors: ["#034694"],
  },
  markers: {
    size: 5,
    hover: {
      size: 9,
    },
    colors: ["#034694"],
  },
  tooltip: {
    x: {
      formatter: function (val: string, i: xConfig): string {
        const date = i.w?.config?.series?.[0]?.data?.[
          i?.dataPointIndex
        ]?.x?.split("-");
        return `${date[2]}/${date[1]}/${date[0]}`;
      },
    },
    y: {
      formatter: function (val: string): string {
        return parseFloat(val).toFixed(1);
      },
    },
  },
};
